import { render, staticRenderFns } from "./OrderListPaginationAndSorting.vue?vue&type=template&id=72a4534c&scoped=true&"
import script from "./OrderListPaginationAndSorting.vue?vue&type=script&lang=ts&"
export * from "./OrderListPaginationAndSorting.vue?vue&type=script&lang=ts&"
import style0 from "./OrderListPaginationAndSorting.vue?vue&type=style&index=0&id=72a4534c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4534c",
  null
  
)

export default component.exports